import {
  GIGAFACTORY_ASSESSMENT,
  SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT,
  PRECURSOR_ASSESSMENT,
  CATHODE,
  LITHIUM_ION_BATTERIES,
  SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT,
} from '~/constants/services/constants'
import { getMenu, getRoutes, getSidebar } from '~/constants/services/methods'
export const MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT = {
  name: GIGAFACTORY_ASSESSMENT.name,
  slug: GIGAFACTORY_ASSESSMENT.slug,
  icon: GIGAFACTORY_ASSESSMENT.iconColor,
  subscription: SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT,
  checkbox: 'battery-cell',
  menu: getMenu(GIGAFACTORY_ASSESSMENT.menu, GIGAFACTORY_ASSESSMENT.slug),
  routes: getRoutes(
    LITHIUM_ION_BATTERIES.slug,
    'capacities',
    false,
    'data-reports/market-assessments',
  ),
  sidebar: getSidebar(
    GIGAFACTORY_ASSESSMENT.slug,
    GIGAFACTORY_ASSESSMENT.sidebar,
    GIGAFACTORY_ASSESSMENT.iconLine,
    [
      { name: 'capacities', path: 'capacities' },
      { name: 'tier ranking', path: 'tier-ranking' },
      { name: 'reports', path: 'reports' },
    ],
  ),
}

export const MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT = {
  name: PRECURSOR_ASSESSMENT.name,
  slug: PRECURSOR_ASSESSMENT.slug,
  icon: PRECURSOR_ASSESSMENT.iconColor,
  subscription: SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT,
  checkbox: null,
  menu: getMenu(PRECURSOR_ASSESSMENT.menu, PRECURSOR_ASSESSMENT.slug),
  routes: getRoutes(
    CATHODE.slug,
    'capacities',
    false,
    'data-reports/market-assessments',
  ),
  sidebar: getSidebar(
    PRECURSOR_ASSESSMENT.slug,
    PRECURSOR_ASSESSMENT.sidebar,
    PRECURSOR_ASSESSMENT.iconLine,
    [
      { name: 'capacities', path: 'capacities' },
      { name: 'reports', path: 'reports' },
    ],
  ),
}
